module.exports = __webpack_public_path__ + "img/ug3312.78da63a9.png";